import styled from 'styled-components';

const CARD_WIDTH = 314;
const border = ({ $selected }) => ($selected ? '#1890ff' : '#e8e8e8');

// Карточка экрана собрана из горизонтальных полос: шапка, по полосе на кнопку, подвал.
// Так дочерний экран может стоять снаружи карточки, но на одной строке со своей кнопкой.
export const NodeHeader = styled.div`
  width: ${CARD_WIDTH}px;
  box-sizing: border-box;
  padding: 12px 12px 10px;
  border: 1px solid ${border};
  border-bottom: 1px solid #f0f0f0;
  border-radius: 8px 8px 0 0;
  background: ${({ $selected }) => ($selected ? '#e6f4ff' : '#fff')};
  cursor: pointer;

  &:hover {
    color: #1890ff;
  }
`;

export const HeaderName = styled.div`
  font-weight: 600;
  font-size: 15px;
  line-height: 1.4;
`;

// Заголовок, который видит клиент. Одна строка с многоточием — подзаголовок уводим
// в подсказку, иначе карточка превращается в простыню текста
export const HeaderTitle = styled.div`
  margin-top: 2px;
  font-size: 12px;
  line-height: 1.4;
  color: #8c8c8c;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CardSlice = styled.div`
  width: ${CARD_WIDTH}px;
  flex: 0 0 ${CARD_WIDTH}px;
  box-sizing: border-box;
  padding: ${({ $first }) => ($first ? '12px 12px 0' : '0 12px')};
  background: #fff;
  border-left: 1px solid ${border};
  border-right: 1px solid ${border};
`;

export const NodeFooter = styled.div`
  width: ${CARD_WIDTH}px;
  box-sizing: border-box;
  height: 12px;
  background: #fff;
  border: 1px solid ${border};
  border-top: none;
  border-radius: 0 0 8px 8px;
`;

// Обёртка тянется вправо на всё поддерево, поэтому подсветку выбранного экрана
// держим на границах самих полос карточки, а не здесь
export const NodeBox = styled.div`
  width: fit-content;
`;

// stretch — чтобы полоса карточки тянулась на всю высоту ветки и контур не разрывался
export const Branch = styled.div`
  display: flex;
  align-items: stretch;
`;

// Воздух между соседними дочерними экранами. Отступ висит на самом блоке, а не на
// строке: полоса карточки тянется на высоту ветки, поэтому контур слева не разрывается
export const ChildSlot = styled.div`
  padding-bottom: 22px;
`;

export const Connector = styled.div`
  flex: 0 0 40px;
  align-self: flex-start;
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #bfbfbf;
  font-size: 18px;
`;

export const Leaf = styled.div`
  align-self: flex-start;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 14px;
  padding: 10px 14px;
  border: 1px solid ${({ $broken }) => ($broken ? '#ffa39e' : '#e8e8e8')};
  border-radius: 8px;
  color: ${({ $broken }) => ($broken ? '#cf1322' : '#595959')};
  background: ${({ $broken }) => ($broken ? '#fff1f0' : '#f5f5f5')};
  font-size: 13px;
  white-space: nowrap;
`;

export const LeafKind = styled.div`
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: .04em;
  color: #bfbfbf;
`;

export const LeafBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const PassRow = styled.div`
  padding: 10px 12px;
  margin-bottom: 8px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  background: #fafafa;
  color: #8c8c8c;
  font-size: 13px;
`;

export const EmptyRow = styled.div`
  padding: 10px 12px;
  margin-bottom: 8px;
  color: #bfbfbf;
  font-size: 13px;
`;
